export const onlyNumbers = /^\d+$/;
